import _defineProperty from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import compact from 'lodash/fp/compact';
export var toUrlParams = function toUrlParams(obj) {
  var isEncode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return Object.keys(obj).reduce(function (acc, k) {
    var startLine = acc ? "".concat(acc, "&") : '';
    var value = obj[k];
    return typeof value !== undefined && value !== null ? "".concat(startLine).concat(k, "=").concat(isEncode ? encodeURIComponent(value) : value) : acc;
  }, '');
};
export var toObject = function toObject() {
  var rawUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var isDecode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '&';
  return !rawUrl ? {} : rawUrl.replace(/^([^?]+\?)|^#|\?/, '').split(separator).map(function (v) {
    return v.split(/^([^=]+)=/).filter(function (v) {
      return v;
    });
  }).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, isDecode ? decodeURIComponent(value) : value));
  }, {});
};
export var getParams = function getParams(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    var value = obj[key];
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, value === '' || value === undefined ? true : value));
  }, {});
};
export var composeUrlQuery = function composeUrlQuery() {
  for (var _len = arguments.length, queries = new Array(_len), _key = 0; _key < _len; _key++) {
    queries[_key] = arguments[_key];
  }

  var queriesWithoutEmpty = compact(queries);
  var composedQueries = queriesWithoutEmpty.join('&');
  return composedQueries && "?".concat(composedQueries);
};